export default class HotelConditions extends HTMLElement {
    constructor() {
        super();
    }

    static get observedAttributes() {
        return ['hotel-conditions-data', 'hotel-schedules-data', 'images', 'stylesheet', 'translations'];
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (this.shadowRoot) {
            this.shadowRoot.querySelector(`[name="${name}"]`).innerHTML = this[name];
        }
    }

    connectedCallback() {
        let shadowRoot = this.attachShadow({mode: 'open'});
        const t = document.querySelector('#hotel-conditions');
        const instance = t.content.cloneNode(true);

        if (
            this.hotelConditionsData !== undefined &&
            this.hotelSchedulesData !== undefined &&
            this.translations !== undefined &&
            this.stylesheet !== undefined
        ) {
            let hotelConditionsDataJson = JSON.parse(this.hotelConditionsData);
            let hotelSchedulesDataJson = JSON.parse(this.hotelSchedulesData);
            let images = JSON.parse(this.images);
            let translations = JSON.parse(this.translations);

            let isAppend = this._appendChild(
                instance,
                hotelConditionsDataJson,
                hotelSchedulesDataJson,
                images,
                translations
            );

            if (isAppend) {
                shadowRoot.appendChild(instance);
            }
        }
    }

    _appendChild(instance, hotelConditionsDataJson, hotelSchedulesDataJson, images, translations) {
        let isAppendTranslations = false;
        let isAppendScheduleAndImages = false;
        let isAppendHotelConditions = false;

        if (translations && Object.keys(translations).length > 0 && this._appendTranslations(instance, translations)) {
            isAppendTranslations = true;
        }

        if (hotelSchedulesDataJson &&
            Object.keys(hotelSchedulesDataJson).length > 0 &&
            Object.keys(images).length > 0 &&
            this._appendSchedulesAndImages(instance, hotelSchedulesDataJson, images, translations)
        ) {
            isAppendScheduleAndImages = true;
        } else {
            instance.querySelector('.schedule-section').style.display = 'none';
        }

        if (Object.keys(hotelConditionsDataJson).length > 0) {
            this._appendHotelConditions(instance, hotelConditionsDataJson);
            isAppendHotelConditions = true;
        }

        instance.querySelector('[name="stylesheet"]').href = this.stylesheet;

        return (isAppendTranslations) && (isAppendScheduleAndImages || isAppendHotelConditions);
    }

    _appendTranslations(instance, translations) {
        let isAppend = false;

        if (
            translations.hasOwnProperty('hotelConditionsTitle')) {
            instance.querySelector('[name="hotel-conditions-title"]').innerHTML = translations.hotelConditionsTitle;
            isAppend = true;
        }

        return isAppend;
    }

    _appendSchedulesAndImages(instance, hotelSchedulesDataJson, images, translations) {
        if (
            !images.hasOwnProperty('checkIn') ||
            !images.hasOwnProperty('checkOut') ||
            !translations.hasOwnProperty('scheduleCheckIn') ||
            !translations.scheduleCheckIn.hasOwnProperty('title') ||
            !translations.scheduleCheckIn.hasOwnProperty('text') ||
            !translations.hasOwnProperty('scheduleCheckOut') ||
            !translations.scheduleCheckOut.hasOwnProperty('title') ||
            !translations.scheduleCheckOut.hasOwnProperty('text')
        ) {
            return false;
        }

        let checkinScheduleText = null;

        if (hotelSchedulesDataJson.first_checkin || hotelSchedulesDataJson.second_checkin) {
            let checkinImg = instance.querySelector('[name="schedule-checkin-section"] [name="schedule-img"]');
            checkinImg.src = images.checkIn;
            checkinImg.alt = 'check in';
            if (hotelSchedulesDataJson.first_checkin && hotelSchedulesDataJson.second_checkin) {
                checkinScheduleText = `${translations.scheduleFromToHour}`;
                checkinScheduleText = checkinScheduleText.replace("%hour1%", `${hotelSchedulesDataJson.first_checkin}`);
                checkinScheduleText = checkinScheduleText.replace("%hour2%", `${hotelSchedulesDataJson.second_checkin}`);
            } else {
                let checkInDate = hotelSchedulesDataJson.first_checkin ? hotelSchedulesDataJson.first_checkin : hotelSchedulesDataJson.second_checkin;
                checkinScheduleText = `${translations.scheduleCheckIn.text} ${checkInDate} h`;
            }
            instance.querySelector('[name="schedule-checkin-section"] [name="schedule-title"]').innerHTML
                = translations.scheduleCheckIn.title;
            instance.querySelector('[name="schedule-checkin-section"] [name="schedule-text"]').innerHTML
                = checkinScheduleText;
        }

        let checkoutScheduleText = null;
        if (hotelSchedulesDataJson.first_checkout || hotelSchedulesDataJson.second_checkout) {
            let checkoutImg = instance.querySelector('[name="schedule-checkout-section"] [name="schedule-img"]')
            checkoutImg.src = images.checkOut;
            checkoutImg.alt = 'check out';

            if (hotelSchedulesDataJson.first_checkout && hotelSchedulesDataJson.second_checkout) {
                checkoutScheduleText = `${translations.scheduleFromToHour}`;
                checkoutScheduleText = checkoutScheduleText.replace("%hour1%", `${hotelSchedulesDataJson.first_checkout}`);
                checkoutScheduleText = checkoutScheduleText.replace("%hour2%", `${hotelSchedulesDataJson.second_checkout}`);
            } else {
                let checkOutDate = hotelSchedulesDataJson.first_checkout ? hotelSchedulesDataJson.first_checkout : hotelSchedulesDataJson.second_checkout;
                checkoutScheduleText = `${translations.scheduleCheckOut.text} ${checkOutDate} h`;
            }
            instance.querySelector('[name="schedule-checkout-section"] [name="schedule-title"]').innerHTML
                = translations.scheduleCheckOut.title;
            instance.querySelector('[name="schedule-checkout-section"] [name="schedule-text"]').innerHTML
                = checkoutScheduleText;
        }

        return true;
    }

    _appendHotelConditions(instance, hotelConditionsDataJson) {
        let conditionsList = instance.querySelector('[name="conditions-list"]');

        hotelConditionsDataJson.forEach((hotelCondition) => {
            let listItem = document.createElement("div");
            let span = document.createElement("span");

            if (hotelCondition.hasOwnProperty('questionText') && hotelCondition.hasOwnProperty('answerText')) {
                span.innerHTML = `<b>${hotelCondition.questionText}:</b>
                                  <span class="hotel-condition-answer-text">${hotelCondition.answerText}</span>
                                  `;
                listItem.appendChild(span);
                conditionsList.appendChild(listItem);
            }
        });
    }

    get hotelConditionsData() {
        return this.getAttribute('hotel-conditions-data');
    }

    get hotelSchedulesData() {
        return this.getAttribute('hotel-schedules-data');
    }

    get images() {
        return this.getAttribute('images');
    }

    get stylesheet() {
        return this.getAttribute('stylesheet');
    }

    get translations() {
        return this.getAttribute('translations');
    }
}
